<template>
<div class="main-sky-wrapper">
  <div style="display: flex; justify-content: center; align-items: center;">
    <button class="btn btn-tabs"  @click="selectedTab = 'initClass'">הפעלת שיעור</button>
    <button class="btn btn-tabs"  @click="selectedTab = 'addClient'">הוספת לקוח</button>
  </div>
  <div class="add-client" v-show="selectedTab === 'addClient'">
    <div class="add-client-form">
      <div class="form-group">
        <label class="head">
          הוספת לקוח
        </label>
      </div>
      <div class="form-group">
        <label>
          שם פרטי
          <input placeholder="שם פרטי" type="text" class="form-control" v-model="newClient.firstName">
        </label>
      </div>
      <div class="form-group">
        <label>
          שם משפחה
          <input placeholder="שם משפחה" type="text" class="form-control" v-model="newClient.lastName">
        </label>
      </div>
      <div class="form-group">
        <label>
          טלפון
          <input placeholder="טלפון" type="tel" class="form-control" v-model="newClient.phone">
        </label>
      </div>
      <div class="form-group">
        <label>
          מייל
          <input placeholder="מייל" type="email" class="form-control" v-model="newClient.mail">
        </label>
      </div>
      <div class="form-group">
        <label>
          ישוב
          <input placeholder="ישוב" type="text" class="form-control" v-model="newClient.residence">
        </label>
      </div>
      <div class="form-group">
        <label>
          איך הגיע אלינו
          <input placeholder="איך הגיע אלינו" type="text" class="form-control" v-model="newClient.howCameToUs">
        </label>
      </div>

      <!--Second phase add client-->
      <div class="form-group">
        <label>
          שיעור חבילות שעות
          <input placeholder="שיעור חבילות שעות" type="text" class="form-control" v-model="newClient.classPackageHours">
        </label>
      </div>

      <div class="form-group">
        <label>
          תשלום
          <input placeholder="תשלום" type="text" class="form-control" v-model="newClient.payment">
        </label>
      </div>
      <button class="btn btn-block btn-info add-client-button">הוספת לקוח</button>
    </div>
  </div>
  <div class="init-class" v-show="selectedTab === 'initClass'">
    <div class="init-class-form">
      <div class="form-group">
        <label class="head">
          הפעלת שיעור
        </label>
      </div>
      <div class="form-group">
        <label>
          שם המדריך
          <input placeholder="שם מדריך" type="text" class="form-control" v-model="newClass.instructorName">
        </label>
      </div>
      <div class="form-group">
        <label>
          סוג שיעור
          <input placeholder="סוג שיעור" type="text" class="form-control" v-model="newClass.classType">
        </label>
      </div>
      <div class="form-group">
        <label>
          שעת שיעור
          <input placeholder="שעת שיעור" type="datetime-local" class="form-control" v-model="newClass.classTime">
        </label>
      </div>
      <div class="form-group">
        <label>
          שם לקוח
          <input placeholder="שם לקוח" type="email" class="form-control" v-model="newClass.clientName">
        </label>
      </div>
      <div class="form-group">
        <label>
          סטטוס תשלום
          <input placeholder="שולם / לא שולם" type="text" class="form-control" v-model="newClass.paymentStatus">
        </label>
      </div>
      <div class="form-group">
        <label>
          התיישב בכיסא
          <input placeholder="התיישב בכיסא" type="text" class="form-control" v-model="newClass.setInChair">
        </label>
      </div>
      <div class="form-group">
        <label>
          זמן זז בלייב
          <input placeholder="זמן זז בלייב" type="text" class="form-control" v-model="newClass.timeMoveLive">
        </label>
      </div>
      <div class="form-group">
        <label>
          התראה לפני סיום שיעור
          <input placeholder="התראה לפני סיום שיעור" type="text" class="form-control" v-model="newClass.alertBeforeClassEnds">
        </label>
      </div>
      <div class="form-group">
        <label>
          התראה לפני סיום שעות
          <input placeholder="התראה לפני סיום שעות" type="text" class="form-control" v-model="newClass.alertBeforeHoursEnd">
        </label>
      </div>
      <div class="form-group">
        <label>
          התחל סימולטור
          <input placeholder="התחל סימולטור" type="datetime-local" class="form-control" v-model="newClass.startSimulator">
        </label>
      </div>
      <div class="form-group">
        <label>
          סיים סימולטור
          <input placeholder="סיים סימולטור" type="datetime-local" class="form-control" v-model="newClass.finishSimulator">
        </label>
      </div>

      <div class="form-group">
        <label>
          סיכום טיסה
          <textarea placeholder="סיכום טיסה" type="text" class="form-control" v-model="newClass.summary"></textarea>
        </label>
      </div>
        <upload-file-input :edit-mode="false"></upload-file-input>
      <button class="btn btn-block btn-info add-client-button">הפעלת שיעור</button>
    </div>
  </div>
</div>
</template>

<script>
import UploadFileInput from "../../contacts/components/AddContactForm/UploadFileInput.component"
export default {
name: "SkySimulator.container",
  components: {UploadFileInput},

  data(){
  return {
    selectedTab: 'initClass',
    newClient:{
      firstName: null,
      lastName: null,
      phone: null,
      mail: null,
      residence: null,
      howCameToUs: null,
      classPackageHours: null,
      payment: null
    },
    newClass: {
      instructorName: null,
      classType: null,
      classTime: null,
      clientName: null,
      paymentStatus: null,
      setInChair: null,
      startSimulator: null,
      finishSimulator: null,
      timeMoveLive: null,
      alertBeforeClassEnds: null,
      alertBeforeHoursEnd: null,
      summary: null,
    }
  }
  }
}
</script>

<style scoped>
.main-sky-wrapper{
  display: flex;
  margin: 2rem;
  flex-direction: column;
  height: 850px;
  overflow-y: scroll;
}
.add-client{
  display: flex;
  width: 100%;
  padding: 5px;
}
.init-class{
  display: flex;
  width: 100%;
  padding: 5px;
}
.init-class-form{
  display: flex;
  width: 100%;
  flex-direction: column;
  direction: rtl;
  margin: 50px;
  padding: 10px;
}
.add-client-form{
  display: flex;
  width: 100%;
  flex-direction: column;
  direction: rtl;
  margin: 50px;
  padding: 10px;
}

.form-group{
  width: 100%;
  margin-right: 5px;
}
.form-control {
  border: 1px none #333;
  border-bottom-style: solid;
  display: block;
  width: 100%;
  height: 32px;
  padding: 0;
  margin-bottom: 15px;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  border-radius: 0;

}

label {
  display: block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 400;
  font-size: 15px;
  font-family: Calibri;
}
.head{
  font-size: 30px;
  font-family: Calibri;
}
.add-client-button{
  font-family: Calibri;
}
.btn-tabs{
  font-family: Calibri;
  font-size: 20px;
  font-weight: 600;
  height: 35px;
  margin: 5px;
}
</style>